import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalController } from '@ionic/angular';
import { DSVRowAny } from 'd3';
import { ToastrService } from 'ngx-toastr';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
interface Recommendation {
  confirmation: boolean;
  extension: boolean;
  promotion: boolean;
  increment: boolean;
  termination: boolean;
}
@Component({
  selector: 'app-add-rating-standerds',
  templateUrl: './add-rating-standerds.component.html',
  styleUrls: ['./add-rating-standerds.component.scss'],
})

export class AddRatingStanderdsComponent implements OnInit {

  checkType: any;
  companyID: any;
  year: any;
  loggedInUserRole: any
  employeedatas: any;
  userId: any;
  hrView: any;
  loggedInUserEmpCode: any
  probationCurrentLogUserType: any
  pmsYears: any;
  selectedYear: any;
  loggedInCompanyFiscalyear: any | null;
  confirmationProbationWhomSetup: any
  fromYear: any;
  toYear: any;
  loggedInUserId: any
  setUps: any
  checkhodbutEmployee: any
  checkSelfEmployee: any;
  employee: any
  empCode: any
  constructor(private dialogRef: MatDialogRef<AddRatingStanderdsComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private config: Config, private encryptionService: EncryptionService,
    private httpService: HttpService, public dialog: MatDialog, private toastr: ToastrService) {
    console.log(data);
    this.checkType = data.type
    this.companyID = data.companyID;
    this.year = data.year;
    this.employeedatas = data;
    this.userId = data?.userId;
    this.hrView = data.hrView;
    this.setUps = data?.setUp;
    this.employee = data?.employee,
      this.checkhodbutEmployee = data?.checkhodbutEmployee;
    this.probationCurrentLogUserType = data?.probationCurrentLogUserType
    this.checkSelfEmployee = data?.checkSelfEmployee
    console.log('received type:', data.type);

  }
  buttonColorName: any;

  ngOnInit() {

    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.empCode = sessionStorage.getItem('empCode');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.confirmationProbationWhomSetup = this.httpService.confirmationProbationWhomSetup;
    this.getpmsyearlist();
    this.getCompanyDataByCompID();
  }


  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.companyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;

      this.setSelectedYear(yearValue);
      // Additional function calls
      this.getTraits();
      this.getTraitsrating();
      this.getEmployeeList();
      // this.getEmployee();
      this.getConfirmation();
      this.getProbationList();
      this.getProbationDetailsForHODAndManager();
      this.getUploadSign();
      if (this.checkType == 'addExit' || this.checkType == 'viewExit') {
        this.getQuestions()
      }
    });
  }

  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYear = selectedYearObj?.year;
      let test = selectedYearObj?.year.split('-');

    }
  }
  form = {
    empCode: 'T1000',
    designation: 'Doc Manager',
    name: 'T Tinu',
    grade: 'G2',
    dateOfJoining: '2008-07-26',
    employmentStatus: 'Probationer',
    du: 'Adrenalin',
    department: 'Account',
    probationDue: '2008-08-05'
  };
  isEditable(employee: any): boolean {


    if (this.setUps == 'setUpView') {
      return true;
    }
    if (!employee) {
      return false;
    }


    const today = new Date();
    const confirmationDate = new Date(employee);
    const fiveDaysBefore = new Date(confirmationDate);
    fiveDaysBefore.setDate(confirmationDate.getDate() - this.noOfDaysConfirmation);





    return today >= fiveDaysBefore || today >= confirmationDate;
  }

  closeModal() {
    this.dialogRef.close();
  }
  addFlag = false;
  addRating() {
    this.addFlag = true
  }

  ratingStandards: any[] = [];
  ratings: any
  getTraits() {
    this.httpService.callGetService(`${this.config.getProbationTraits}/${this.companyID}/${this.year}`).subscribe((res: any) => {


      this.ratingStandards = res.data;

      this.ratings = this.ratingStandards.map((elm: any) => {
        // check if this trait already has a rating
        console.log(this.traitsRatingGet);
        let accoudingToUser = this.traitsRatingGet.filter((elm: any) => elm.userId == this.userId)
        const matchData = accoudingToUser.find((e: any) => e.traitId === elm.id);
        console.log(matchData);

        return {
          ...elm,
          outstanding: matchData?.ratingName === 'outstanding' || null,
          veryGood: matchData?.ratingName === 'veryGood' || null,
          good: matchData?.ratingName === 'good' || null,
          average: matchData?.ratingName === 'average' || null,
          belowAverage: matchData?.ratingName === 'belowAverage' || null,
          ratingId: matchData?.ratingId || null,
          whoChangedForm: matchData?.whoChangedForm || null
        };
      });
    })
  }
  checkpoint() {
    console.log(this.ratings);

  }


  salary = {
    proposed: '₹80,000',
    approved: '₹78,000'
  };

  formsalary = {
    presentSalary: '₹75,000'
  };

  columns: string[] = ['sl', 'point', 'outstanding', 'good', 'average', 'poor'];
  editIndex: number | null = null;
  editableValue: string = '';
  editableValueForExitQus: string = '';
  performanceStandard: string = ''
  onClickEditConfirm(index: number, currentValue: any) {
    this.editIndex = index;
    this.editableValue = currentValue.traitName;
    this.editableValueForExitQus = currentValue.fieldName;
  }

  onClickCloseForDays() {
    this.editIndex = null;
    this.editableValue = '';
    this.editableValueForExitQus = ''
  }

  saveConfirmation(item: any) {
    console.log(item);

    if ((!this.performanceStandard.trim() && item == null)) {
      this.toastr.error('Please enter traits before submitting.');
      return;
    }
    if (!this.editableValue?.trim() && item !== null) {
      this.toastr.error('Please enter traits before submitting.');
      return;
    }
    let payload = {
      "id": item?.id ? item?.id : null,
      "traitName": this.performanceStandard?.trim() || this.editableValue?.trim(),
      "companyId": this.companyID,
      "year": this.year
    }
    this.httpService.callPostService(`${this.config.addProbationTraits}`, payload).subscribe({

      next: (data: any) => {

        this.toastr.success(data?.data?.message); // 👈 Show toast
        this.editIndex = null;
        this.editableValue = '';
        this.performanceStandard = ''
        this.getTraits();


      },
      error: (error: any) => {
        this.toastr.error(error.message);
        this.editIndex = null;
        this.editableValue = '';
        this.getTraits();

      }
    });
  }
  submitForm() {
    console.log('Form submitted:', this.form);
    alert('Form submitted successfully!');
  }

  @ViewChild('signatureLine') signatureLine!: ElementRef;
  showImage: any
  onSignatureUpload(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (file) {
      this.showImage = URL.createObjectURL(file); // <-- this is the correct way
    }
  }
  traitsRatingGet: any = []
  getTraitsrating() {
    this.httpService.callGetService(`${this.config.getTraitsRating}/${this.companyID}/${this.selectedYear}`).subscribe((res: any) => {
      console.log(res.data);
      this.traitsRatingGet = res.data
      this.getTraits();

    })
  }

  selectedRatings: any
  selectOnlyOne(rowIndex: number, field: string, traitId: any) {
    if (this.setUps !== '' || this.setUps == null) {
      const fields = ['outstanding', 'veryGood', 'good', 'average', 'belowAverage'];

      // Reset all checkboxes in this row
      fields.forEach(f => {
        this.ratings[rowIndex][f] = false;
      });

      // Set the clicked one to true
      this.ratings[rowIndex][field] = true;
    }
    let payload = {
      "ratingId": traitId?.ratingId || null,
      "ratingName": field,
      "traitId": traitId.id,
      "companyId": this.companyID,
      "userId": this.userId,
      "year": this.selectedYear,
      "whoChangedForm": this.loggedInUserRole
      //   "isDeleted": false
    }
    if (this.setUps == '' || this.setUps == null) {

      this.httpService.callPostService(this.config.addOrUpdateTraitRating, payload).subscribe({
        next: (data: any) => {
          this.toastr.success(data.message); // 👈 Show toast
          this.getTraitsrating()
        },
        error: (error: any) => {
          this.toastr.error(error.message);
          this.getTraitsrating()

        }
      });
    }
  }
  recommendation: Recommendation = {
    confirmation: false,
    extension: false,
    promotion: false,
    increment: false,
    termination: false
  };
  recommandationFrom: any
  selectOnlyOnerecommendation(item: keyof Recommendation) {
    Object.keys(this.recommendation).forEach(key => {
      this.recommendation[key as keyof Recommendation] = (key === item);

    });
    console.log(item);
    this.recommandationFrom = item
  }


  // ---------------------------------------------------------------------------------------------------------------------------------
  checkEditAccss: any;
  lineManagerOrHODData: any = [];
  getProbationDetailsForHODAndManager() {
    this.httpService.callGetService(`${this.config.getDetailsLineManagerOrHOD}?companyId=${this.companyID}&year=${this.year}`).subscribe((record: any) => {
      if (record) {
        console.log("record", record);
        console.log(this.hrView);

        if (this.hrView == 'HR Admin' || this.hrView == 'Admin' || this.hrView == 'Super Admin' || this.hrView == 'PHI Admin') {
          let filterData = record?.data.filter((elm: any) => elm.userId == this.userId)


          this.lineManagerOrHODData = filterData.map((res: any) => {
            const matchUser = record?.data.find((elm: any) => elm.userId == this.userId);
            if (matchUser?.recommendationComment &&
              (matchUser.recommendationComment === 'confirmation' ||
                matchUser.recommendationComment === 'extension' ||
                matchUser.recommendationComment === 'promotion' ||
                matchUser.recommendationComment === 'increment' ||
                matchUser.recommendationComment === 'termination')) {
              this.recommendation[matchUser.recommendationComment as keyof Recommendation] = true;
            }
            this.recommandationFrom = matchUser?.recommendationComment || null
            this.hodComment = matchUser?.hodComment || null
            this.managerComment = matchUser?.managerComment || null
            this.hrComment = matchUser?.hrComment || null
            this.employeeComment = matchUser?.employeeComment || null

            return {
              ...res,
              emplCode: res ? res?.empCode || matchUser?.empCode : null,
              probationExtensionByDay: res ? res?.probationExtensionByDay || matchUser?.probationExtensionByDay : null,
              probationStatus: res ? res?.probationStatus || matchUser?.probationStatus : null,
              reasonForExtension: matchUser ? matchUser.reasonForExtension : null,
              probationDetailId: matchUser ? matchUser.probationDetailId : null,
              dateOfConfirmation: matchUser ? matchUser.dateOfConfirmation : res.dateOfConfirmation,
              whoChangedForm: matchUser ? matchUser.whoChangedForm : res.whoChangedForm,
              dateOfJoining: (matchUser !== undefined && matchUser?.doj !== null) ? matchUser?.doj : res?.doj,
            }
          })
        } else if (!this.checkSelfEmployee && (this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Manager')) {
          console.log("inside hod manager", this.employeesProbationDetails);
          console.log(this.checkSelfEmployee);

          this.employeesProbationDetails = this.employeesProbationDetails?.filter((record: any) => record.userId == this.userId)
          console.log("employeesProbationDetails", this.employeesProbationDetails);

          this.lineManagerOrHODData = this.employeesProbationDetails?.map((res: any) => {
            const matchUser = record?.data?.find((elm: any) => elm.userId == res.userId);
            console.log("matchUser", matchUser);

            if (matchUser?.recommendationComment &&
              (matchUser.recommendationComment === 'confirmation' ||
                matchUser.recommendationComment === 'extension' ||
                matchUser.recommendationComment === 'promotion' ||
                matchUser.recommendationComment === 'increment' ||
                matchUser.recommendationComment === 'termination')) {
              this.recommendation[matchUser.recommendationComment as keyof Recommendation] = true;
            }
            this.recommandationFrom = matchUser?.recommendationComment || null
            this.hodComment = matchUser?.hodComment || null
            this.managerComment = matchUser?.managerComment || null
            this.hrComment = matchUser?.hrComment || null
            this.employeeComment = matchUser?.employeeComment || null
            return {
              ...res,
              probationExtensionByDay: res ? res?.probationExtensionByDay || matchUser?.probationExtensionByDay : null,
              probationStatus: res ? res?.probationStatus || matchUser?.probationStatus : null,
              reasonForExtension: matchUser ? matchUser.reasonForExtension : null,
              probationDetailId: matchUser ? matchUser.probationDetailId : null,
              dateOfConfirmation: matchUser ? matchUser.dateOfConfirmation : res.dateOfConfirmation,
              whoChangedForm: matchUser ? matchUser.whoChangedForm : res.whoChangedForm,
              dateOfJoining: (matchUser !== undefined && matchUser?.doj !== null) ? matchUser?.doj : res?.dateOfJoining,
            }
          })



        }
        else if (this.loggedInUserRole === 'Employee' || this.checkhodbutEmployee == true) {

          console.log(this.currentemployeesProbationDetails);

          this.employeesProbationDetails = this.employeesProbationDetails?.filter((record: any) => record.userId == this.loggedInUserId)
          console.log(this.employeesProbationDetails);

          this.lineManagerOrHODData = this.employeesProbationDetails?.map((res: any) => {
            const matchUser = record?.data?.find((elm: any) => elm.userId == res.userId);
            if (matchUser?.recommendationComment &&
              (matchUser.recommendationComment === 'confirmation' ||
                matchUser.recommendationComment === 'extension' ||
                matchUser.recommendationComment === 'promotion' ||
                matchUser.recommendationComment === 'increment' ||
                matchUser.recommendationComment === 'termination')) {
              this.recommendation[matchUser.recommendationComment as keyof Recommendation] = true;
            }
            this.recommandationFrom = matchUser?.recommendationComment || null
            this.hodComment = matchUser?.hodComment || null
            this.managerComment = matchUser?.managerComment || null
            this.hrComment = matchUser?.hrComment || null
            this.employeeComment = matchUser?.employeeComment || null
            return {
              ...res,
              probationExtensionByDay: res ? res?.probationExtensionByDay || matchUser?.probationExtensionByDay : null,
              probationStatus: res ? res?.probationStatus || matchUser?.probationStatus : null,
              reasonForExtension: matchUser ? matchUser.reasonForExtension : null,
              probationDetailId: matchUser ? matchUser.probationDetailId : null,
              dateOfConfirmation: matchUser ? matchUser.dateOfConfirmation : res.dateOfConfirmation,
              dateOfJoining: (matchUser !== undefined && matchUser?.doj !== null) ? matchUser?.doj : res?.dateOfJoining,
            }
          }
          )
        }
      }
    })
  }
  probationListData: any = [];
  employeesProbationDetails: any = [];
  currentemployeesProbationDetails: any = [];
  employeesDetails: any = []
  probationPeriodData: any = []
  getconfirmationdata: any = [];
  noOfDaysConfirmation: any;
  getConfirmation() {
    // this.httpService.callGetService(`${this.config.getConfirmationSetUp}/${this.loggedInUserCompanyID}`)
    this.httpService.callGetService(`${this.config.getConfirmationSetUp}?companyId=${this.companyID}&year=${this.selectedYear}`)
      .subscribe((record: any) => {
        this.getconfirmationdata = record.data;

        this.noOfDaysConfirmation = record?.data[0]?.noOfDayBeforeConfirmation;

      })
  }
  getprobationPeriods() {
    this.httpService.callGetService(`${this.config.getProbation}?companyId=${this.companyID}&year=${this.year}`)
      .subscribe((record: any) => {
        console.log("API Response:", record);
        this.probationPeriodData = record.data;
        this.getProbationList();
      });
  }

  getEmployeeList() {

    // this.selectedYear
    this.httpService.callGetService(`${this.config.getProbationDetails}?companyId=${this.companyID}&yearRange=${this.selectedYear}&fiscalType=${this.loggedInCompanyFiscalyear}`).subscribe((record: any) => {
      this.employeesDetails = record.data.map((record: any) => {
        return {
          ...record,
          probationStatus: null,
          probationExtensionByDay: null,
          reasonForExtension: null,
          changesPostConfirmation: null,
          dateOfConfirmation: null
        }
      });
      this.getprobationPeriods()

    })
  }
  getProbationList() {
    this.httpService.callGetService(`${this.config.getProbationDetailsWithConfirmationDate}?companyId=${this.companyID}&year=${this.year}`)
      .subscribe((response: any) => {

        if (!response || !response?.data) return;
        this.probationListData = response?.data;
        this.currentemployeesProbationDetails = this.employeesDetails?.map((employee: any) => {

          // Find probation period based on band and grade
          let probationData = this.probationPeriodData?.find((elm: any) =>
            elm.band === employee.band && elm.grade === employee.grade
          );

          // If no matching probation data, set confirmation date as null
          if (!probationData) {
            return {
              ...employee,
              probationStatus: null,
              probationExtensionByDay: null,
              reasonForExtension: null,
              dateOfConfirmation: null, // Set to null if no match
              changesPostConfirmation: null
            };
          }

          let probationPeriod = probationData.probationPeriod; // Months


          // Find employee probation details
          let matchData = this.probationListData.find((elm: any) =>
            elm.empCode === employee.emplCode && elm.grade === employee.grade
          );

          // Convert joining date
          let dateOfJoining = new Date(employee.dateOfJoining); // Convert to Date object
          let finalConfirmationDate = new Date(dateOfJoining); // Create a new Date instance;




          // Add probation period (in months)
          finalConfirmationDate.setMonth(finalConfirmationDate.getMonth() + probationPeriod);

          // If probation is extended, add extra extension days
          if (matchData?.probationStatus === "Extension") {
            finalConfirmationDate.setDate(finalConfirmationDate.getDate() + matchData.probationExtensionByDay);
          }


          return {
            ...employee, // Keep existing employee data
            probationDetailId: matchData ? matchData?.probationDetailId : null,
            probationStatus: matchData ? matchData?.probationStatus : employee?.probationStatus || null,
            probationExtensionByDay: matchData ? matchData.probationExtensionByDay : employee?.probationExtensionByDay || null,
            reasonForExtension: matchData ? matchData.reasonForExtension : null,
            dateOfConfirmation: matchData?.dateOfConfirmation ? matchData?.dateOfConfirmation : finalConfirmationDate.toISOString().split('T')[0], // Format YYYY-MM-DD
            changesPostConfirmation: matchData ? matchData.changesPostConfirmation : null,
          };
        });
        if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Admin') {
          this.employeesProbationDetails = this.currentemployeesProbationDetails;
        } else if (this.loggedInUserRole == 'Manager' && !this.checkhodbutEmployee) {
          console.log("manager11", this.currentemployeesProbationDetails);
          console.log(this.loggedInUserEmpCode);

          this.employeesProbationDetails = this.currentemployeesProbationDetails.filter((record: any) => this.loggedInUserEmpCode == record.reportingManagerCode);


          console.log("uuuuuuuuuu" + this.employeesProbationDetails);
          this.currentemployeesProbationDetails = this.employeesProbationDetails

        } else if (this.loggedInUserRole == 'HOD' && !this.checkhodbutEmployee) {

          console.log("hod11");
          if (this.loggedInUserRole == 'HOD') {

            this.employeesProbationDetails = this.currentemployeesProbationDetails.filter((record: any) => this.loggedInUserEmpCode == record.hodCode ||record?.reportingManagerCode == record.hodCode);
            console.log(this.employeesProbationDetails);

            this.currentemployeesProbationDetails = this.employeesProbationDetails
          }

          else {
            this.employeesProbationDetails = this.currentemployeesProbationDetails.filter((record: any) => record?.reportingManagerCode == record.hodCode);
            console.log(this.employeesProbationDetails);

            this.currentemployeesProbationDetails = this.employeesProbationDetails
          }

        } else if (this.loggedInUserRole === 'Employee' || this.checkhodbutEmployee == true) {


          console.log("employee", this.currentemployeesProbationDetails);


          this.employeesProbationDetails = this.currentemployeesProbationDetails.filter((record: any) => this.loggedInUserId == record.userId);


          this.currentemployeesProbationDetails = this.employeesProbationDetails
        }


        this.getProbationDetailsForHODAndManager();

      });
  }
  emailOfHrAdmin: any;
  firstnameOfHrAdmin: any;
  lastnameOfHrAdmin: any;
  companyHrId: any;
  hodComment: any;
  managerComment: any;
  hrComment: any;
  employeeComment: any;
  getCompanyDataByCompID() {

    this.httpService.callGetService(this.config.getCompanyDataByCompID + this.companyID).subscribe((data: any) => {


      this.emailOfHrAdmin = data?.data?.emailOfHrAdmin;
      this.firstnameOfHrAdmin = data?.data?.firstnameOfHrAdmin;
      this.lastnameOfHrAdmin = data?.data?.lastnameOfHrAdmin;
      this.companyHrId = data?.data?.companyHrId;


    })
  }
  getProbationEmployeeDetails: any;
  SaveProbationData(userId: any) {
    console.log(this.lineManagerOrHODData);

    this.getProbationEmployeeDetails = this.lineManagerOrHODData[0];
    console.log(this.getProbationEmployeeDetails);
    console.log(this.recommandationFrom);

    if (!this.getProbationEmployeeDetails) {
      this.toastr.error("No employee data found to update");
      return;
    }

    if (!this.recommandationFrom) {
      this.toastr.error("Please select a recommendation option");
      return;
    }

    console.log(this.hrComment);

    let formData = {
      "probationDetailId": this.getProbationEmployeeDetails?.probationDetailId || null,
      "hrId": this.companyHrId,
      "userId": userId,
      "companyId": this.companyID,
      "year": this.selectedYear,
      "fiscalYear": this.loggedInCompanyFiscalyear,
      "empName": this.getProbationEmployeeDetails?.empName,
      "empCode": this.getProbationEmployeeDetails?.emplCode,
      "empDept": this.getProbationEmployeeDetails?.empDept,
      "band": this.getProbationEmployeeDetails?.band,
      "grade": this.getProbationEmployeeDetails?.grade,
      "doj": this.getProbationEmployeeDetails?.dateOfJoining,
      // "probationStatus": "Confirmation", // 1. Confirmation 2. Extension
      "probationStatus": this.getProbationEmployeeDetails?.probationStatus, // 1. Confirmation 2. Extension
      "probationExtensionByDay": this.getProbationEmployeeDetails?.probationExtensionByDay,
      "reasonForExtension": this.getProbationEmployeeDetails?.reasonForExtension,
      "changesPostConfirmation": this.getProbationEmployeeDetails?.changesPostConfirmation, // 1. No_Change 2. Change_Needed
      "dateOfConfirmation": this.getProbationEmployeeDetails?.dateOfConfirmation,
      // "officialEmail": "nikitanalawade2001@gmail.com",
      "hrName": this.firstnameOfHrAdmin + " " + this.lastnameOfHrAdmin,
      "hrEmail": this.emailOfHrAdmin,
      "probationCurrentLogUserType": this.loggedInUserRole == 'Manager' ? ' LINE_MANAGER' : this.loggedInUserRole == 'HOD' ? 'HOD' : null,
      "hodComment": this.hodComment || null,
      "hrComment": this.hrComment || null,
      "recommendationComment": this.recommandationFrom,
      "managerComment": this.managerComment || null,
      "employeeComment": this.employeeComment || null,
      "whoChangedForm": this.loggedInUserRole
    }

    console.log(formData);



    this.httpService.callPostService(this.config.addUpdateProbationDetailsForHodAndLine, formData).subscribe((record: any) => {
      if (record) {
        this.toastr.success(record.message);
        this.dialogRef.close()
      }
    },
      (error: any) => {

        this.toastr.error(error.error.message)
      }

    );

  }

  // __________________-------------------------------------------------------SignUpload------------------------------------------------------


  signfileNameForApiAppend: any;
  showSignBrowseBtn: boolean = false;
  isDraggingSign: boolean = false;
  onDragLeaveSign(event: DragEvent) {
    event.preventDefault();
    this.isDraggingSign = false; // Reset the drag state
  }

  onFileDroppedSign(event: DragEvent) {
    event.preventDefault();
    this.isDraggingSign = false; // Reset the drag state

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.handelSignFile(event); // Process the first file
    }
  }
  isDisabledUploadPolicyBtnForSign: boolean = true;
  handelSignFile(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;

    const fileSizeInMB = file.size / (1024 * 1024);

    // ✅ Allowed image extensions only
    const allowedExtensions = ['png', 'jpg', 'jpeg'];
    const extension = file.name.split('.').pop()?.toLowerCase();

    if (!extension || !allowedExtensions.includes(extension)) {
      window.alert("Only image files are allowed (PNG, JPG, JPEG).");
      return;
    }

    // ✅ Restrict to 2 MB max
    if (fileSizeInMB > 2) {
      window.alert("File size should not exceed 2MB.");
      return;
    }

    this.signfileNameForApiAppend = file;
    if (file) {
      this.signfileNameForApiAppend = file;
      // Create a preview URL for the uploaded file
      this.showImage = URL.createObjectURL(file);
    }
    this.onClickUploadSign()


  }
  checkbackendDataForSign: any
  // ... existing code ...

  getUploadSign() {
    this.httpService.callGetService(this.config.getOfferLetter + this.companyID + '?fileFor=HODSIGNATURE&year=' + this.selectedYear)
      .subscribe((result: any) => {
        console.log(result.data);
        if (result.data != null) {
          this.checkbackendDataForSign = result.data;
          this.signfileNameForApiAppend = result.data;
          this.showSignBrowseBtn = true;

          // Set the image URL correctly
          this.showImage = `${this.config.downloadFile}${this.companyID}/${result.data}`;
        } else {
          this.signfileNameForApiAppend = '';
          this.showSignBrowseBtn = false;
          this.isDisabledUploadPolicyBtnForSign = true;
          this.showImage = null; // Clear the image if no data
        }
      });
  }

  // ... existing code ...


  onClickUploadSign() {
    if (!this.signfileNameForApiAppend) {
      console.error("No file selected.");
      return;
    }

    const formData = new FormData();
    formData.append("file", this.signfileNameForApiAppend); // Must be a File object
    formData.append("companyId", this.companyID);
    formData.append("fileFor", "HODSIGNATURE");

    formData.append("candidateId", "");
    formData.append("uploadByUserId", String(this.loggedInUserId));
    formData.append("fiscalYear", this.loggedInCompanyFiscalyear);
    formData.append("year", this.selectedYear);

    // Debug log
    formData.forEach((value, key) => console.log(key, value));

    this.httpService.submitFormService(this.config.uploadSignature, formData).subscribe({
      next: (result: any) => {
        if (result) {

          this.isDisabledUploadPolicyBtnForSign = true;
          this.getUploadSign();


        }
      },
      error: (err) => {
        console.error("Upload error:", err);

        const errorMessage = err?.error?.message || 'Something went wrong during upload.';


      }
    });
  }
  onClickCancelUploadletterHead(Sign: any, type: any) {


    if (Sign != undefined) {

      this.httpService.callDeleteService(`${this.config.deleteLetterHead}?fileName=${Sign}&companyId=${this.companyID}`)
        .subscribe((result: any) => {
          if (result) {


          }
        })
    }

  }
  // -----------------------------------------------------------------for EXit-----------------------------------------------------
  fieldName: any;
  quetionsList: any = []
  getQuestions() {
    this.httpService.callGetService(`${this.config.getQuetionsData}=${this.companyID}&year=${this.year}`).subscribe((res: any) => {

      this.quetionsList = res.data;

    })
  }
  saveQuestion(item: any) {
    if ((!this.fieldName?.trim() && item == null)) {
      this.toastr.error('Please enter question before submitting.');
      return;
    }
    if (!this.editableValueForExitQus?.trim() && item !== null) {
      this.toastr.error('Please enter question before submitting.');
      return;
    }
    let payload = {
      "id": item?.id || null,
      "companyId": this.companyID,
      "year": this.year,
      "fieldName": this.fieldName?.trim() || this.editableValueForExitQus?.trim(),
      "fieldValue": "",

    }
    this.httpService.callPostService(`${this.config.addUpdateQuestionExit}`, payload).subscribe({

      next: (data: any) => {

        this.toastr.success(data.message); // 👈 Show toast
        this.editIndex = null;
        this.editableValue = '';
        this.fieldName = ''
        this.getQuestions();


      },
      error: (error: any) => {
        this.toastr.error(error.message);
        this.editIndex = null;
        this.editableValue = '';
        this.getQuestions();

      }
    });
  }
  deleteQuestion(item: any) {
    this.httpService.callPutService(`${this.config.deleteQuestions}?id=${item?.id}`, '').subscribe({

      next: (data: any) => {

        this.toastr.success(data.message); // 👈 Show toast
        this.editIndex = null;
        this.editableValue = '';
        this.fieldName = ''
        this.getQuestions();


      },
      error: (error: any) => {
        this.toastr.error(error.message);
        this.editIndex = null;
        this.editableValue = '';
        this.fieldName = ''
        this.getQuestions();

      }
    });
  }

}